import { render, staticRenderFns } from "./form-input2_after.vue?vue&type=template&id=059236fe&scoped=true&"
import script from "./form-input2_after.vue?vue&type=script&lang=js&"
export * from "./form-input2_after.vue?vue&type=script&lang=js&"
import style0 from "./form-input2_after.vue?vue&type=style&index=0&id=059236fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059236fe",
  null
  
)

export default component.exports